import { IoIosArrowDown } from 'react-icons/io';
import styled from 'styled-components';

// StyledSelect 수정
const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100px;
`;

const StyledSelect = styled.select<{ $selectedValue: string }>`
  width: 100%;
  padding: 8px;
  padding-right: 30px; /* 아이콘 공간 확보 */
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: #f8f9fa;
  color: ${(props) =>
    props.$selectedValue === 'RESERVED'
      ? '#0083D4'
      : props.$selectedValue === 'FINISHED'
        ? '#D40000'
        : '#000'}; /* 선택된 값에 따라 색상 변경 */
  appearance: none; /* 기본 화살표 제거 */
  outline: none;

  &:hover {
    border-color: #85c1a9;
  }

  &:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.25);
  }
`;

const StyledOption = styled.option<{ value: string; disabled?: boolean }>`
  background-color: ${(props) => (props.disabled ? '#ddd' : '#fff')};
  color: ${(props) =>
    props.disabled
      ? '#fff' // disabled일 경우 회색
      : props.value === 'RESERVED'
        ? '#0083D4' // RESERVED는 파란색
        : props.value === 'FINISHED'
          ? '#D40000' // FINISHED는 빨간색
          : '#000'}; // 기본 검정색
  font-size: 14px;
  text-decoration: ${(props) =>
    props.disabled
      ? 'line-through'
      : 'none'}; // disabled 옵션에 가운데 라인 추가

  &:hover {
    background-color: ${(props) => (props.disabled ? '#ddd' : '#f1f1f1')};
  }
`;

// 화살표 아이콘 Wrapper
const ArrowIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 10px; /* 오른쪽 여백 */
  transform: translateY(-50%);
  pointer-events: none; /* 클릭 방지 */
  font-size: 16px;
  color: #555;
`;

// Props 타입 정의
interface Option {
  value: string;
  label: string;
  disabled?: boolean; // 옵션 비활성화 여부
}

interface CustomSelectProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Option[];
}

function CustomSelect({ value, onChange, options }: CustomSelectProps) {
  return (
    <SelectWrapper>
      <StyledSelect value={value} onChange={onChange} $selectedValue={value}>
        {options.map((option) => (
          <StyledOption
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </StyledOption>
        ))}
      </StyledSelect>
      <ArrowIcon>
        <IoIosArrowDown />
      </ArrowIcon>
    </SelectWrapper>
  );
}

export default CustomSelect;
